// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29xyC","toggleWrap":"styles_toggleWrap__2bdVe","content":"styles_content__DE505","selectAreaCode":"styles_selectAreaCode__efsUG"};